import { render } from "./intangibleOffline.vue?vue&type=template&id=0f4f5fc6&scoped=true"
import script from "./intangibleOffline.vue?vue&type=script&lang=js"
export * from "./intangibleOffline.vue?vue&type=script&lang=js"

import "./intangibleOffline.vue?vue&type=style&index=0&id=0f4f5fc6&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f4f5fc6"]])

export default __exports__